import React from "react";
import CountUp from "react-countup";

export default function ProfileCounter({ allContracts, maintenanceSchedules }) {
  return (
    <>
      <div className="companyCounters d-flex justify-content-center">
        <div className="companyCounter text-center me-3">
          <h6>
            <CountUp end={allContracts?.length} duration={5} />
          </h6>
          <p>العقود</p>
        </div>
        <div className="companyCounter text-center ms-3">
          <h6>
            <CountUp end={maintenanceSchedules?.length} duration={5} />
          </h6>
          <p>
            جداول <br /> الصيانة
          </p>
        </div>
      </div>
    </>
  );
}
